import { useEffect, useState } from 'react';
import { SITE, SECTION_IDS } from '../content/site';
import { ROUTES, useLocale } from '../i18n/locale';

/**
 * Phones: a persistent but quiet "Iniciar proyecto" bar after the hero. It steps aside over the request
 * forms, the dense one-screen sections (China, visibility) and the footer so it never covers content.
 */
export function StickyCta() {
  const { locale } = useLocale();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0; const height = window.innerHeight;
      const past = window.scrollY > height * 0.9;
      const covering = [...document.querySelectorAll(['need', 'sourcing', 'visibility', 'start'].map(key => `#${SECTION_IDS[key as keyof typeof SECTION_IDS][locale]}`).concat('.site-footer').join(', '))].some(element => { const r = element.getBoundingClientRect(); return r.top < height && r.bottom > 0; });
      setVisible(past && !covering);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    update(); window.addEventListener('scroll', schedule, { passive: true });
    return () => { window.removeEventListener('scroll', schedule); if (frame) cancelAnimationFrame(frame); };
  }, [locale]);
  return (
    <div className="sticky-cta" data-visible={visible} aria-hidden={!visible}>
      <a className="cta cta--primary" href={ROUTES.intake[locale]} tabIndex={visible ? 0 : -1}>{SITE[locale].start}</a>
    </div>
  );
}
